import axios from 'axios';
import Qs from 'qs';
import {
	dayEnd,
	dayStart,
} from "../../components/DateUtil";
import { BASEURL } from '../common/config'
// const url = 'https://www.energydt.cn/api' //公司线上服务器
const url = BASEURL
// const url = 'https://local.vrmaker.vip:37086/' //公司线上服务器



// 通过回路id查询极值
export const EXTREMUM_VALUES = (ids, nodes, type, date) => {
	return axiosApi("get", "/extremum/values")({
		ids: ids.join(","),
		nodes: nodes.join(","),
		type,
		"start": dayStart(date),
		"end": dayEnd(date),
	})
}

/**
 * 用Create方法来创建axios请求对象
 */

export const INITAXIOS = axios.create({
    timeout: 30000, // 请求超时时间
    baseURL: url, //线上公司服务器
    method: 'post',
    headers: {
        'Content-Type': "application/x-www-form-urlencoded",
    },
    transformRequest: data => {
        let result = Qs.stringify(data);
        return result
    }
})

/**
 * 用来创建普通请求方法
 * @param api
 * @returns {function(*=): Promise<AxiosResponse<T>>}
 */
export function axiosApi(type, api, header) {
    header ? header : header = {};
    return data => {
        switch (type) {
            case 'get':
                return INITAXIOS({
                    url: api,
                    params: data,
                    method: 'get',
                    headers: {
                        'authorization': 'Bearer ' + 'VrMakerToken',
                        ...header
                    }
                })
            case 'post':
                return INITAXIOS({
                    url: api,
                    data: data,
                    method: 'post',
                    headers: {
                        'authorization': 'Bearer ' + 'VrMakerToken',
                        ...header
                    }
                })
            case 'put':
                return INITAXIOS({
                    url: api,
                    data: data,
                    method: 'put',
                    headers: {
                        'authorization': 'Bearer ' + 'VrMakerToken',
                        ...header
                    }
                })
            case 'delete':
                return INITAXIOS({
                    url: api,
                    data: data,
                    method: 'delete',
                    headers: {
                        'authorization': 'Bearer ' + 'VrMakerToken',
                        ...header
                    }
                })
        }
    }
}


// -------  api区域  ------------
// 获取所有区域电能统计
const PowerAreasAnalysis = axiosApi('get', '/power/areas/analysis')

// 根据区域id获取区域能源分析
const PowerAnalysisArea = axiosApi('get', '/power/powerAnalysis/area')

// 获取项目能源分析
const powerAnalysis = axiosApi('get', '/power/powerAnalysisByProjectOfIn')

// 根据区域id获取区域进线
const loopMasterArea = axiosApi('get', '/loop/master/area')

// 根据回路id和点位名获取相应数据历史曲线
const loopHistorycurve = axiosApi('get', '/diagram/loop/historycurve')

// 根据回路id和点位名获取相应数据历史曲线
const projectTime = axiosApi('get', '/project/time/deployment')

// 根据区域id获取区域回路的详细信息
const areaLoops = axiosApi('get', '/loop/area/all/details')

// 获取项目的日均负荷率
const dayLoad = axiosApi('get', '/diagram/influxdb/data/load')

// 按时间查询项目用电 
const diagramDay = axiosApi('get', '/diagram/generation')

// 按时间查询项目用电 每天小时
const diagramDayhourlyIntervals = axiosApi('get', '/diagram/generation/hourlyIntervals')

// 按时间查询项目用电 
const diagramAreaDay = axiosApi('get', '/diagram/generation/area')

// 按时间查询回路三相温度
const loopTemperature = axiosApi('get', '/diagram/loop/historycurve/threetemperature')

// 查询报警事件
const alarmEvent = axiosApi('get', '/alarm/event/statistics')

// 获取项目信息
const getBaseInfo = axiosApi('get', '/project/info')

// 获取能耗同环比
const getPowerCompare = axiosApi('get', '/power/compare')

// 获取能耗同环比(按时间范围)
const getPowerCompareData = axiosApi('get', '/power/compare/data')

// 获取能耗同环比(按时间范围)
const navMenu = axiosApi('get', '/threeDimensionalMenu/tree')

// 获取能耗
const energyConsumption = axiosApi('get', '/diagram/classifiedEnergyConsumptionOfProject')

// 获取能耗同环比
const energyCompare = axiosApi('get', '/power/project/compareClassifiedPower')

// 获取能耗月同比
const energyCompareMonth = axiosApi('get', '/power/project/compareClassifiedPowerMonthOnMonth')

// 获取折标煤
const getConvertedStandardCoal = axiosApi('get', '/diagram/classifiedEnergyConsumptionOfProject/convertedStandardCoal')

// 获取项目尖峰平谷
const getpowerAnalysisByProjectOfOut = axiosApi('get', '/power/powerAnalysisByProjectOfOut')

// 获取项目总用电 （无进线情况下）
const getPowerOut = axiosApi('get', '/power/total/out')

// 获取项目楼宇数量  
const getBuildCount = axiosApi('get', '/building/count')

// 获取折煤标
const getConsumptionSC = axiosApi('get', '/power/energyConsumptionSC/proportion')

// 获取建筑
const getBuildTree = axiosApi('get', '/building/treeBuilding')

// 获取建筑分类能耗
const getBuildTreeEnergy = axiosApi('get', '/power/buildingTree/item')

// 获取分项能耗图表
const getEnergyConsumption = axiosApi('get', '/diagram/itemEnergyConsumption')

// 获取分项能耗图表
const getEnergyConsumptionProject = axiosApi('get', '/diagram/itemEnergyConsumption/project')

// 按日期获取分期能耗
const getDateEnergyProject = axiosApi('get', '/power/project/itemEnergyConsumption')

// 按分页查询门禁列表(只能在鲁泰大楼那边使用)
const getDoorsList = axiosApi('get', '/access/door/list')

// 获取门禁当前状态 
const getDoorsStatus = axiosApi('get', '/access/online')



export default {
    PowerAreasAnalysis,
    PowerAnalysisArea,
    loopMasterArea,
    loopHistorycurve,
    projectTime,
    areaLoops,
    dayLoad,
    diagramDay,
    diagramAreaDay,
    loopTemperature,
    alarmEvent,
    getBaseInfo,
    powerAnalysis,
    getPowerCompare,
    getPowerCompareData,
    diagramDayhourlyIntervals,
    navMenu,
    energyConsumption,
    energyCompare,
    energyCompareMonth,
    getConvertedStandardCoal,
    getpowerAnalysisByProjectOfOut,
    getPowerOut,
    getBuildCount,
    getConsumptionSC,
    getBuildTree,
    getBuildTreeEnergy,
    getEnergyConsumption,
    getEnergyConsumptionProject,
    getDateEnergyProject,
    getDoorsList,
    getDoorsStatus
}

